import { RouteObject } from "react-router"
import {ContasListView} from "./contas.view"
import ContaDetalhe from "./view/conta.detalhes"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Archive } from "@mui/icons-material"

export enum PathRotaContas {
    contas = "/contas",
    detalhes = "/contas/detalhes"
}


const routerContas: RouteObject = {
    path: PathRotaContas.contas,
    element: <ContasListView />,
}

export const routerContaDetalhe:RouteObject = {
    path: PathRotaContas.detalhes,
    element: <ContaDetalhe />,
}



export const navigationToContasView = ()=> rotas.navigate(PathRotaContas.contas)
export const navigationToContaDetalheView = ()=> rotas.navigate(PathRotaContas.detalhes)

export function startRouterContas(){
    const menu:MainMenu = {
        text:"Contas",
        icon:<Archive />,
        eventOnClick:navigationToContasView,
    }
    menuRotas.push(menu);
    return routerContas
}